import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft, ArrowRight, Wrench } from 'lucide-react';
import OpenGraphMeta from '@/components/OpenGraphMeta';
import SiteFooter from '@/components/SiteFooter';

const LivePortfolio = () => {
  return (
    <div className="min-h-screen bg-background">
      <OpenGraphMeta
        title="Live Portfolio — Under Rebuild | GoToCoins"
        description="The Live Portfolio feature is being rebuilt with verified live pricing and real trade resolution. See our Track Record for verified pick performance."
        url="https://gotocoins.lovable.app/live-portfolio"
      />

      <div className="container mx-auto px-4 py-10 max-w-2xl">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8">
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </Link>

        <Card className="border-border/60">
          <CardContent className="p-8">
            <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center mb-5">
              <Wrench className="w-5 h-5 text-muted-foreground" />
            </div>
            <h1 className="text-2xl font-bold text-foreground mb-3">Live Portfolio is temporarily offline</h1>
            <p className="text-muted-foreground leading-relaxed">
              We're rebuilding this feature properly — verified live pricing and real trade resolution —
              before bringing it back. In the meantime, see our Track Record for verified pick performance.
            </p>
            <Link to="/track-record" className="inline-block mt-6">
              <Button className="gap-2">
                View Track Record
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>

      <SiteFooter />
    </div>
  );
};

export default LivePortfolio;
